import { database } from '../index';
import { BUSINESS_SCHEMA, CATEGORY_SCHEMA, STOCK_SCHEMA } from '../schema';
import { Q } from '@nozbe/watermelondb';

const stock_categories = database.collections.get(CATEGORY_SCHEMA)

export const getStockCategory = (business_id) => stock_categories.query(Q.on(BUSINESS_SCHEMA, 'id', business_id), Q.on(STOCK_SCHEMA, "archived", Q.notEq(true)), Q.where('level', 1)).observe()

export const getBusinessCatgories = (business_id) => stock_categories.query(Q.on(BUSINESS_SCHEMA, 'id', business_id)).observe()

export const getCatgoriesByCatgories = (business_id) => stock_categories.query(Q.on(BUSINESS_SCHEMA, 'id', business_id)).fetch()

export const getLevelOneCategories = (business_id) => stock_categories.query(Q.on(BUSINESS_SCHEMA, 'id', business_id), Q.where('level', 1)).observe()

export const createManualCategory = (business, category) => {
    return new Promise((resolve, reject) => {
        let masterData = {
            name: 'General',
            image_url: '',
            level: 0
        }
        business.createMasterCategory(masterData).then(masterRes => {
            let catData = {
                category: masterRes,
                name: category,
                image_url: '',
                level: 1
            }
            business.createCategory(catData).then(categoryRes => {
                resolve(categoryRes);
            }).catch(e => {
                reject(e)
            })
        }).catch(e => {
            reject(e)
        })
    });
}

export const bulkCreateCategories = async (business, masterCategory) => {
    return await Promise.all(masterCategory.map(async master => {
        try {
            let masterData = {
                name: master.name,
                image_url: master.image_url,
                level: 0
            }

            let masterRes = await business.createMasterCategory(masterData);

            await Promise.all(master.categories.map(async cat => {

                let catData = {
                    category: masterRes,
                    name: cat.name,
                    image_url: cat.image_url,
                    level: 1
                }

                let categoryRes = await business.createCategory(catData)

                await Promise.all(cat.sub_categories.map(async sub_category => {

                    let subCatData = {
                        category: categoryRes,
                        name: sub_category.name,
                        image_url: sub_category.image_url,
                        level: 2
                    }

                    let subCategoryRes = await business.createCategory(subCatData)

                    await Promise.all(sub_category.sub_sub_categories.map(async sub_sub_category => {

                        let subSubCatData = {
                            category: subCategoryRes,
                            name: sub_sub_category.name,
                            image_url: sub_sub_category.image_url,
                            level: 3
                        }
                        await business.createCategory(subSubCatData)
                    }))
                }))
            }))
        } catch (err) {
        }
    }))
}


export const bulkDeleteCategoriesByBusiness = async (business_id) => {
    await database.write(async () => {
        let categories = await getCatgoriesByCatgories(business_id);
        const allRecords = await prepareDeletion(categories);
        await database.batch(...allRecords);
    });
};

const prepareDeletion = async (categories) => {
    return await Promise.all(
        categories.map(async (category) => {
            try {
                return category.prepareMarkAsDeleted();
            } catch (err) {
            }
        })
    );
};




